import React from "react";

/** Stable unique keys for excursion groups (`g-1`, `g-2`, …) across sync/rebuild. */
export function useNextGroupLocalKey(): () => string {
  const groupLocalCounterRef = React.useRef(0);

  return React.useCallback(() => {
    groupLocalCounterRef.current += 1;

    return `g-${groupLocalCounterRef.current}`;
  }, []);
}
